import {
  getToken as _getToken,
  onMessage as _onMessage
} from "firebase/messaging";
import { useNuxtApp } from "#imports";
export function useFcm() {
  const { $fcm } = useNuxtApp();
  async function getToken() {
    if ($fcm?.messaging) {
      return _getToken($fcm.messaging).catch((error) => {
        console.warn(error);
        return void 0;
      });
    }
  }
  function onMessage(cb) {
    if ($fcm?.messaging) {
      _onMessage($fcm.messaging, cb);
    }
  }
  return { getToken, onMessage };
}
